import { useEffect, useState } from "react";
import { PrimaryModal } from "../../../Components/StyledComponents/Modal";
import { P } from "../../../Components/StyledComponents/Paragraph";
import { PrimarySelect } from "../../../Components/StyledComponents/Select";
import { SimpleFlex } from "../../../Components/StyledComponents/SimpleFlex";
import { useDispatch } from "react-redux";
import { addPlant } from "../../../redux/slice/Plants/plant";
import { SimpleButton } from "../../../Components/StyledComponents/SimpleButton";
import { PrimaryButton } from "../../../Components/StyledComponents/Button";
import { Form } from "antd";
import { SimpleInput } from "../../../Components/StyledComponents/SimpleInput";
import "./AddPlant.scss";

function AddPlant({ closeButton }) {
  const dispatch = useDispatch();
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [loading, setLoading] = useState(false);

  const [selectedRow, setSelectedRow] = useState({
    productName: "",
    description: "",
    shortName: "",
    assignOwners: [],
  });

  const handleSelectChange = (selectedValues) => {
    setSelectedRow((prevState) => ({
      ...prevState,
      assignOwners: selectedValues,
    }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSelectedRow((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

      return newState;
    });
  };

  const handleOk = async () => {
    setLoading(true);

    try {
      dispatch(addPlant(selectedRow));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      console.log("Plant added successfully!");
    } catch (error) {
      console.error("Error adding plant:", error);
    } finally {
      setLoading(false);
      closeButton();
    }
  };

  const handleCancel = () => {
    closeButton();
  };

  useEffect(() => {
    const { productName, description, shortName, assignOwners } = selectedRow;
    const formComplete =
      productName?.trim() !== "" &&
      description?.trim() !== "" &&
      shortName?.trim() !== "" &&
      assignOwners?.length > 0;

    setIsFormComplete(formComplete);
  }, [selectedRow]);

  const AddModalfooter = (
    <SimpleFlex margin="1.5rem 0 0 0" alignitems="center">
      <SimpleFlex gap="1rem" width="auto">
        <SimpleButton onClick={handleCancel} padding="0.5rem 1rem">
          Cancel
        </SimpleButton>
        <PrimaryButton
          disabled={!isFormComplete}
          loading={loading}
          onClick={handleOk}
          padding="0.5rem 1rem"
        >
          Save Changes
        </PrimaryButton>
      </SimpleFlex>
    </SimpleFlex>
  );

  return (
    <PrimaryModal
      centered
      title="Add Plant"
      open
      onOk={handleOk}
      onCancel={handleCancel}
      footer={AddModalfooter}
      maskClosable={false}
    >
      <Form>
        <SimpleFlex flexdirection="column" gap="1rem">
          <SimpleFlex flexdirection="column" gap="1rem">
            <P color="var(--nav-color)" fontsize="0.75rem">
              Plant
            </P>
            <Form.Item
              name="productName"
              className="margin-0"
              rules={[
                {
                  required: true,
                  message: "Please input plant!",
                },
              ]}
              initialValue={selectedRow?.productName}
            >
              <SimpleInput
                bordered={false}
                name="productName"
                onChange={handleInputChange}
                style={{ borderBottom: "1px solid black" }}
                className="user-input"
                padding="0 0 0.3rem 0"
                color="var(--black)"
                borderradius="0"
                fontsize="1rem"
              />
            </Form.Item>
          </SimpleFlex>
          <SimpleFlex flexdirection="column" gap="1rem">
            <P color="var(--nav-color)" fontsize="0.75rem">
              Description
            </P>
            <Form.Item
              name="description"
              className="margin-0"
              rules={[
                {
                  required: true,
                  message: "Please input description!",
                },
              ]}
              initialValue={selectedRow?.description}
            >
              <SimpleInput
                bordered={false}
                name="description"
                onChange={handleInputChange}
                style={{ borderBottom: "1px solid black" }}
                className="user-input"
                padding="0 0 0.3rem 0"
                color="var(--black)"
                borderradius="0"
                fontsize="1rem"
              />
            </Form.Item>
          </SimpleFlex>

          <SimpleFlex flexdirection="column" gap="1rem">
            <P color="var(--nav-color)" fontsize="0.75rem">
              Short Name
            </P>
            <Form.Item
              name="shortName"
              className="margin-0"
              rules={[
                {
                  required: true,
                  message: "Please input Short Name!",
                },
              ]}
              initialValue={selectedRow?.shortName}
            >
              <SimpleInput
                bordered={false}
                name="shortName"
                onChange={handleInputChange}
                style={{ borderBottom: "1px solid black" }}
                className="user-input"
                padding="0 0 0.3rem 0"
                color="var(--black)"
                borderradius="0"
                fontsize="1rem"
              />
            </Form.Item>
          </SimpleFlex>
          <SimpleFlex flexdirection="column" gap="1rem">
            <P color="var(--nav-color)" fontsize="0.75rem">
              Assign Owners
            </P>
            <Form.Item
              name="assignOwners"
              className="margin-0"
              rules={[
                {
                  required: true,
                  message: "Please input Owner!",
                },
              ]}
              initialValue={selectedRow?.assignOwners}
            >
              <PrimarySelect
                bordered={false}
                className="user-select"
                mode="multiple"
                showSearch
                allowClear
                onChange={handleSelectChange}
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input)
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                options={[
                  {
                    value: "Abdul Nizam",
                    label: "Abdul Nizam",
                  },
                  {
                    value: "Billal Ahmed",
                    label: "Billal Ahmed",
                  },
                  {
                    value: "Mohammed Waris",
                    label: "Mohammed Waris",
                  },
                  {
                    value: "Mohammed Rizwan",
                    label: "Mohammed Rizwan",
                  },
                  {
                    value: "Babar Azam",
                    label: "Babar Azam",
                  },
                ]}
              />
            </Form.Item>
          </SimpleFlex>
        </SimpleFlex>
      </Form>
    </PrimaryModal>
  );
}
export default AddPlant;
